import Pqp from "../3x1010/Pqp.js";
//import Sounder from "./Tools/sounder/Sounder";
import MainLoop from "./Tools/MainLoop";
import Spran from "./Tools/spran/Spran";
import Controls from "./Tools/controls/Controls";
import Game from "./Game.js";
import Sprites from "./Tools/Sprites.js";
import Main from "./Main.js";
import Sounder from "./Tools/sounder/Sounder.js";

export default class ScreenAttract {
  constructor(callback) {
    this.callback = callback;
    this.tick = 0;
  }

  init() {
    

    this.mc = jQuery("#template-attract-screen").clone();
    this.mc.removeAttr("id");


    jQuery(".js-main").append(this.mc);

    if (Main.savegame.skipIntro) {
      this.mc.on("click", this.skip.bind(this))
      
    }


    let div = jQuery(".js-logo", this.mc);
    let anim = JSON.parse(JSON.stringify(ScreenAttract.LOGO));
    let spran = new Spran(div, anim, this.logoEventHandlers.bind(this));
    spran.init();
    spran.setAnimation("default");
    MainLoop.subscribe(spran)
    MainLoop.subscribe(this, "onMainLoop");
    this.logo = spran;

    MainLoop.start();

    let sp;
    sp = Sprites.getSpriteByRowCol("aztec", 0, 0);
    jQuery(".js-aztec",this.mc).css("background-image", "url('" + sp + "')");
    sp = Sprites.getSpriteByRowCol("challenge", 0, 0);
    jQuery(".js-challenge", this.mc).css("background-image", "url('" + sp + "')");
    sp = Sprites.getSpriteByRowCol("tribute", 0, 0);
    jQuery(".js-tribute", this.mc).css("background-image", "url('" + sp + "')");


    //Sounder.play("intro");
    Main.that.sounder.play("intro");

    this.initListeners();

    if (Pqp.isMobile()) {
      jQuery(".do-tap", this.mc).show();
      jQuery(".do-click", this.mc).hide();
    } else {
      jQuery(".do-tap", this.mc).hide();
      jQuery(".do-click", this.mc).show();
    }


  }
  skip() {
    if (Pqp.isMobile()) {
      if (!Pqp.isIos()) {
        let element = jQuery("body").get(0);
        element.requestFullscreen();
      }
    }

    this.dispatch({ type: ScreenAttract.EVENT_ENDED });
  }

  initListeners() {
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    jQuery(window).on("blur", this.onMinimize.bind(this));
    jQuery(window).on("focus", this.onMaximize.bind(this));
  }

  onMinimize() {
    //Sounder.pauseAll();
    Main.that.sounder.pause("intro");
    MainLoop.pause();
  }
  onMaximize() {
    //Sounder.resumeAll();
    Main.that.sounder.resume("intro");
    MainLoop.resume();
  }



  logoEventHandlers(e) {
    if (e.type === Spran.EVENT_END_ANIMATION) {
      Main.savegame.skipIntro = true;
      Main.updateSavegame();
      this.dispatch({ type: ScreenAttract.EVENT_ENDED });
    }

  }


  onMainLoop() {
    this.tick++;
    if (Main.savegame.skipIntro) {
      if (this.tick >= 120) {
        jQuery(".js-bottom-skip", this.mc).show();
      }
      if (this.tick >= 360) {
        jQuery(".js-bottom-skip", this.mc).hide();
      }
    }

    if (this.tick >= 500) {
      jQuery(".js-aztec", this.mc).show();
      jQuery(".js-challenge", this.mc).show();
      jQuery(".js-tribute", this.mc).show();
      

    }

  }

  destroy() {
    //Sounder.stop("intro");
    Main.that.sounder.stop("intro");
    jQuery(window).off("blur");
    jQuery(window).off("focus");

    this.logo.pause();
    MainLoop.unsubscribe(this);
    MainLoop.unsubscribe(this.logo);
    MainLoop.stop();
    this.mc.remove();
  }


  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }

}

ScreenAttract.EVENT_ENDED = "eventEnded";
ScreenAttract.LOGO_TIME = 100;
ScreenAttract.LOGO = [
  {
    id: "default",
    sheet: "logo",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 5900 },
      { row: 0, col: 1, time: ScreenAttract.LOGO_TIME },
      { row: 0, col: 2, time: ScreenAttract.LOGO_TIME },
      { row: 0, col: 3, time: ScreenAttract.LOGO_TIME },
      { row: 1, col: 0, time: ScreenAttract.LOGO_TIME },
      { row: 1, col: 1, time: ScreenAttract.LOGO_TIME },
      { row: 1, col: 2, time: ScreenAttract.LOGO_TIME },
      { row: 1, col: 3, time: ScreenAttract.LOGO_TIME },
      { row: 2, col: 0, time: ScreenAttract.LOGO_TIME },
      { row: 2, col: 1, time: ScreenAttract.LOGO_TIME },
      { row: 2, col: 2, time: ScreenAttract.LOGO_TIME },
      { row: 2, col: 3, time: ScreenAttract.LOGO_TIME },
      { row: 3, col: 0, time: ScreenAttract.LOGO_TIME },
      { row: 3, col: 1, time: ScreenAttract.LOGO_TIME },
      { row: 3, col: 2, time: ScreenAttract.LOGO_TIME },
      { row: 3, col: 3, time: 5400 },
    ]
  },
]

